export const DUMMY_DATA = [
    {
      "date": "250",
      "description": "Der traditionalistische Kaiser Decius l\u00e4sst den vernachl\u00e4ssigten Kaiserkult wiederaufleben. Allgemein herrscht im R\u00f6mischen Reich Religionsfreiheit, der Kaiserkult ist die einzige religi\u00f6se Handlung, die zwingend verlangt wird. Dabei muss jeder B\u00fcrger den verstorbenen, vom Senat zum Divus erkl\u00e4rten Kaisern huldigen, z. B. indem er in einem Tempel eine Weihrauchkerze anz\u00fcndet. Einzig das Christentum, das sich seit einiger Zeit in den St\u00e4dten des Reichs verbreitet, lehnt den Kaiserkult vehement ab. Dies f\u00fchrt zu einer erneuten Verfolgung der Religion. Viele Christen, darunter auch Bisch\u00f6fe, sagen sich von ihrem Glauben los.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Diva_Faustina_Pfau.JPG/150px-Diva_Faustina_Pfau.JPG",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "250",
      "description": "Zeit der Drei Reiche: Kaiser Sun Quan der Wu-Dynastie zwingt in Nanking seinen Sohn Sun Ba aufgrund seiner st\u00e4ndigen Angriffe gegen Kronprinz Sun He zum Suizid. Anstelle von Sun He ernennt er anschlie\u00dfend seinen j\u00fcngsten Sohn Sun Liang zum neuen Kronprinzen. Mehrere Offizielle, die sich gegen diesen Schritt wenden, werden entweder hingerichtet oder ebenfalls zum Suizid gezwungen.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/41/China_5.jpg/150px-China_5.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Kaiserreich China",
      "granularity": "year"
    },
    {
      "date": "250/01/20",
      "description": "Fabianus, der Bischof von Rom, stirbt w\u00e4hrend der Christenverfolgung. Aufgrund dieser wird zun\u00e4chst kein neuer Bischof gew\u00e4hlt. Novatian wird zun\u00e4chst zum Sprecher der Gemeinde berufen. Fabianus wird in der Calixtus-Katakombe beigesetzt. ''Sein Sarkophag wird 1915 wiederentdeckt.''",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Ravensburg_Gesellschaftskapelle_Fenster_4_Fabianus.jpg/96px-Ravensburg_Gesellschaftskapelle_Fenster_4_Fabianus.jpg",
      "category1": "Religion",
      "granularity": "year"
    },
    {
      "date": "250/01/20",
      "description": "(um) Entstehung des Bartholom\u00e4usevangeliums.",
      "lang": "de",
      "category1": "Religion",
      "granularity": "year"
    },
    {
      "date": "251",
      "description": "Kaiser Decius gibt das Amt des Censors an Valerian. Der Censor hat unter anderem die Aufgabe, die B\u00fcrger des R\u00f6mischen Reichs in verschiedene W\u00e4hlerklassen und Tribus einzuordnen. Au\u00dferdem ernennt Decius seinen \u00e4lteren Sohn Herennius Etruscus zum Augustus und somit zum ihm gleichgestellten Mitregenten.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Emperor_Traianus_Decius_%28Mary_Harrsch%29.jpg/112px-Emperor_Traianus_Decius_%28Mary_Harrsch%29.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "251",
      "description": "Fr\u00fchjahr: Goten, Gepiden und Karpen \u00fcberqueren erstmals in gro\u00dfer Zahl die Donau und pl\u00fcndern r\u00f6mische St\u00e4dte in Dakien, anschlie\u00dfend auch in Moesien, Thrakien und Illyrien. Es beginnt der so genannte \u201eGotensturm\u201c. Als die Karpen die Stadt Nikopolis belagern, werden sie von der r\u00f6mischen Armee unter Decius und Herennius Etruscus \u00fcberrascht und vertrieben. Die weitgehend unverteidigte Provinz Moesia Inferior wird w\u00e4hrenddessen Ziel der gotischen Krieger unter K\u00f6nig Kniva. Die R\u00f6mer k\u00f6nnen nicht verhindern, dass Philippopolis in die Hand der Goten f\u00e4llt.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/F%C3%ADbula_aquiliforme_%28M.A.N._Madrid%29_01.jpg/90px-F%C3%ADbula_aquiliforme_%28M.A.N._Madrid%29_01.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "251",
      "description": "Priscus, der Bruder des von Decius gest\u00fcrzten Kaisers Philippus Arabs, dem die \u00f6stlichen Provinzen unterstehen, verb\u00fcndet sich mit den Goten und ruft sich in Naissus zum Gegenkaiser aus.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Bust_of_emperor_Philippus_Arabus_-_Hermitage_Museum.jpg/108px-Bust_of_emperor_Philippus_Arabus_-_Hermitage_Museum.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "251",
      "description": "Juni: Die Goten, geschw\u00e4cht durch die Belagerung von Philippopolis, bieten Decius an, ihm f\u00fcr freies Geleit aus dem Reich ihre gesamte Beute und ihre Gefangenen zu \u00fcberlassen. In Anbetracht seiner gest\u00e4rkten milit\u00e4rischen Lage verweigert Decius Verhandlungen mit den Goten. Knivas Truppen verlassen Philippopolis und versuchen, die r\u00f6mischen Grenzen zu erreichen.ampbrampAu\u00dferhalb von Philippopolis treffen R\u00f6mer und Goten aufeinander. Kaiser Herennius Etruscus wird von einem Pfeil t\u00f6dlich getroffen. Die Goten k\u00f6nnen mitsamt ihrer Beute entkommen.",
      "lang": "de",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "251",
      "description": "Anstatt sich neu zu formieren, verfolgt Herennius\u2019 Vater, Kaiser Decius, die Goten und versucht ihnen den Weg zur r\u00f6mischen Grenze abzuschneiden. Bei Abrittus (heute Razgrad, Bulgarien) kommt es erneut zum Kampf. In der Schlacht von Abrittus gelingt es K\u00f6nig Kniva, die R\u00f6mer ins Sumpfland abzudr\u00e4ngen. Er teilt seine 70.000 Krieger in mehrere kleinere Gruppen auf und kann so die r\u00f6mische Legion umzingeln. Der Kampf wird f\u00fcr die R\u00f6mer zur bedeutenden Niederlage: Auch Decius kommt durch die Goten ums Leben. Er und sein Sohn Herennius Etruscus sind die ersten r\u00f6mischen Kaiser, die im Kampf gegen eine fremde Armee sterben.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/de/thumb/c/ca/Arch%C3%A4ologiezone_Abritus.jpg/150px-Arch%C3%A4ologiezone_Abritus.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "251",
      "description": "Als der Tod der Kaiser bekannt wird, wird Decius\u2019 16-j\u00e4hriger Sohn Hostilian Kaiser. In Moesia aber erheben die Truppen nach Decius\u2019 Tod ihren Heerf\u00fchrer, den Statthalter von Moesia Superior, Trebonianus Gallus zum Gegenkaiser. Um weitere K\u00e4mpfe zu vermeiden, wird Hostilian von Gallus adoptiert. Nominell sind beide als Kaiser gleichgestellt, de facto hat Hostilian wegen seines jungen Alters noch wenig Einfluss auf das Geschehen im Reich.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/Sestertius_Hostilian-s2771.jpg/150px-Sestertius_Hostilian-s2771.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "251",
      "description": "Trebonianus Gallus handelt in Moesien mit Kniva einen Friedensvertrag aus: Die Goten d\u00fcrfen mit ihrer Beute in ihre Heimat zur\u00fcckkehren. Sie geloben die Respektierung der Grenzen des R\u00f6mischen Reichs und erhalten daf\u00fcr j\u00e4hrliche Tributzahlungen. Der Vertrag gilt als eine der schwersten Niederlagen der R\u00f6mer.",
      "lang": "de",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "251",
      "description": "November: Kaiser Hostilian erkrankt in Viminatium an der Pest und stirbt binnen kurzer Zeit. Sein Leichnam wird vor Ort verbrannt und in einem eigenen Mausoleum bestattet. Hostilian ist der erste r\u00f6mische Kaiser seit 40 Jahren, der eines nat\u00fcrlichen Todes stirbt.ampbramp''Die \u00dcberreste der Stadt Viminatium und des Mausoleums, heute auf serbischem Gebiet, werden derzeit erforscht.''",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Viminacium_camp_l%C3%A9gionnaire.jpg/150px-Viminacium_camp_l%C3%A9gionnaire.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "251",
      "description": "In Rom ernennt Kaiser Trebonianus Gallus seinen Sohn Volusianus zum Mitherrscher.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Aureus_Volusianus.jpg/150px-Aureus_Volusianus.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "251",
      "description": "Zeit der Drei Reiche: Kriegsherr Wang Ling plant den Sturz des Wei-Regenten Sima Yi, um seinen eigenen Sohn Cao Biao das Amt \u00fcbernehmen zu lassen. Sima Yi erf\u00e4hrt von der Verschw\u00f6rung und kann sie vereiteln.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/41/China_5.jpg/150px-China_5.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Kaiserreich China",
      "granularity": "year"
    },
    {
      "date": "251",
      "description": "Die Kaiserin der Wei-Dynastie Zhen stirbt in Luoyang. Sie wird unter dem postumen Namen ''sanfte, aber fr\u00fch verstorbene Kaiserin'' mit kaiserlichen Ehren bestattet.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/China_edcp_location_map.svg/150px-China_edcp_location_map.svg.png",
      "category1": "Politik und Weltgeschehen",
      "category2": "Kaiserreich China",
      "granularity": "year"
    },
    {
      "date": "251",
      "description": "Der Wei-Regent Sima Yi stirbt. Sein Sohn Sima Shi \u00fcbernimmt sein Amt.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/41/China_5.jpg/150px-China_5.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Kaiserreich China",
      "granularity": "year"
    },
    {
      "date": "251",
      "description": "Der Kaiser der Wu-Dynastie Sun Quan ernennt in Nanking Pan, die Mutter seines Kronprinzen, zur Kaiserin.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/41/China_5.jpg/150px-China_5.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Kaiserreich China",
      "granularity": "year"
    },
    {
      "date": "251",
      "description": "M\u00e4rz: W\u00e4hrend einer Unterbrechung der Christenverfolgung wird Cornelius zum Bischof von Rom gew\u00e4hlt. Dieser will die w\u00e4hrend der Verfolgung aus der Gemeinde ausgetretenen Christen (''lapsi'') wiederaufnehmen. Novatian emp\u00f6rt sich dar\u00fcber, da nicht die Kirche, sondern nur Gott die Macht zur Vergebung habe.",
      "lang": "de",
      "category1": "Religion",
      "granularity": "year"
    },
    {
      "date": "251",
      "description": "Mai: Die Synode von Karthago behandelt das Thema der Lapsi.",
      "lang": "de",
      "category1": "Religion",
      "granularity": "year"
    },
    {
      "date": "251",
      "description": "Juli: Der r\u00f6mische Senat beschlie\u00dft, dass Herennius Etruscus und Decius in den G\u00f6tterhimmel aufgenommen werden.",
      "lang": "de",
      "category1": "Religion",
      "granularity": "year"
    },
    {
      "date": "251",
      "description": "Herbst: Novatian wird auf einer kirchlichen Synode in Rom exkommuniziert. Er gr\u00fcndet daraufhin die kirchliche Gemeinschaft der Novatianer.",
      "lang": "de",
      "category1": "Religion",
      "granularity": "year"
    },
    {
      "date": "252",
      "description": "Valerian stellt die rund zehn Jahre zuvor aufgel\u00f6ste Legio III Augusta mit Soldaten aus Raetia und Noricum wieder auf. Sie sollen das R\u00f6mische Reich gegen die Berber verteidigen. Ihr Motto wird ''Iterum Pia Iterum Vindex'' (\u201eerneut treu, erneut der R\u00e4cher\u201c).",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Aureus_Valerian-RIC_0034-transparent.png/150px-Aureus_Valerian-RIC_0034-transparent.png",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "252",
      "description": "R\u00f6misch-Persische Kriege: Das Sassanidenreich unter Schah Schapur I. greift die Ostgrenze des R\u00f6mischen Reichs an. Seine Armee zieht Richtung Mittelmeer in die Provinz Syria. Die hiesigen r\u00f6mischen Truppen werden in der Schlacht von Barbalissos geschlagen. Die Stadt Zeugma wird zerst\u00f6rt.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Roman_expansion_264_BC_Shepherd.jpg/150px-Roman_expansion_264_BC_Shepherd.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "252",
      "description": "Schapur I. erobert das K\u00f6nigreich Armenien.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Armenian_Empire.png/150px-Armenian_Empire.png",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "252",
      "description": "Zeit der Drei Reiche: Zhang wird in Luoyang von Wei-Kaiser Cao Fang zur Kaiserin erhoben.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/41/China_5.jpg/150px-China_5.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Kaiserreich China",
      "granularity": "year"
    },
    {
      "date": "252",
      "description": "W\u00e4hrend Wu-Kaiser Sun Quan dem Tode nahe ist, wird seine Frau, Kaiserin Pan, unter ungekl\u00e4rten Umst\u00e4nden ermordet. Bald darauf stirbt Sun Quan im Alter von 70ampampnbspJahren. Ihm folgt sein erst 9-j\u00e4hriger Sohn Sun Liang. Zhuge Ke wird sein Regent.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/41/China_5.jpg/150px-China_5.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Kaiserreich China",
      "granularity": "year"
    },
    {
      "date": "252",
      "description": "Wei-Regent Sima Shi beginnt einen Feldzug gegen die Wu-Dynastie, die nach dem Tod ihres Kaisers geschw\u00e4cht ist. Regent Zhuge Ke kann die Invasion jedoch aufhalten und Sima Shi zur\u00fcckschlagen. Sima Shi \u00fcbernimmt die Verantwortung f\u00fcr die Niederlage und bef\u00f6rdert jene Gener\u00e4le, die ihm von dem Angriff abgeraten hatten.",
      "lang": "de",
      "category1": "Politik und Weltgeschehen",
      "category2": "Kaiserreich China",
      "granularity": "year"
    },
    {
      "date": "252/05/15",
      "description": "Zweite Synode von Karthago",
      "lang": "de",
      "category1": "Religion",
      "granularity": "year"
    },
    {
      "date": "253",
      "description": "Der K\u00f6nig des Sassanidenreichs, Schapur I., beendet seinen Feldzug gegen Rom mit der Eroberung der Stadt Antiochia am Orontes in der Provinz Syria. Aus Schapurs Sicht wichtiger ist aber seine nun unbestrittene Herrschaft \u00fcber Mesopotamien und Armenien.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Bas_relief_nagsh-e-rostam_al.jpg/150px-Bas_relief_nagsh-e-rostam_al.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "253",
      "description": "In Moesia Superior kommt es zum Konflikt mit den Goten \u00fcber die festgelegten Tributzahlungen Roms. Es ist nicht eindeutig \u00fcberliefert, ob K\u00f6nig Kniva mehr Geld verlangt oder ob Statthalter Aemilianus, der von der afrikanischen Insel Djerba stammt, den f\u00fcr Rom schmachvollen Tribut absichtlich zur\u00fcckh\u00e4lt. Gotische Krieger \u00fcberschreiten die Donau. Sie werden von der r\u00f6mischen Legion, gef\u00fchrt von Aemilianus, geschlagen. Dieser wird daraufhin von seinen Truppen zum Gegenkaiser ausgerufen und marschiert gen Rom.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Roman_provinces_of_Illyricum%2C_Macedonia%2C_Dacia%2C_Moesia%2C_Pannonia_and_Thracia.jpg/150px-Roman_provinces_of_Illyricum%2C_Macedonia%2C_Dacia%2C_Moesia%2C_Pannonia_and_Thracia.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "253",
      "description": "Juli: Die Kaiser Trebonianus Gallus und Volusianus sammeln ihre Truppen in Italia. Auch Valerian, der Statthalter von Raetia und Noricum, wird um Hilfe gerufen. Bei Interamna treffen die Heere aufeinander, noch bevor Valerian mit seinen Legionen eingreifen kann. Die Schlacht wird f\u00fcr die kaiserlichen Truppen zur Niederlage. Trebonianus Gallus und sein Sohn Volusianus setzen sich mit einer Gruppe \u00dcberlebender nach Norden ab. Beim Forum Flaminii werden die Kaiser von ihren eigenen Soldaten umgebracht. Aemilianus wird r\u00f6mischer Kaiser. Zugleich l\u00e4sst sich Valerian im Norden Italias von seinen Truppen zum Gegenkaiser ausrufen.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/8/82/083_Trebonianus_Gallus.jpg/150px-083_Trebonianus_Gallus.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "253",
      "description": "Die Alamannen zerst\u00f6ren das r\u00f6mische Kastell Biriciana, heute als Kastell Wei\u00dfenburg bekannt.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/d/df/Wolfskrieger_2.jpg/112px-Wolfskrieger_2.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "253",
      "description": "September: Kaiser Aemilianus \u00fcberl\u00e4sst die F\u00fchrung Roms dem Senat, um als Heerf\u00fchrer einen Feldzug gegen die Germanen in Thrakien und die Perser in Syria zu f\u00fchren. Als das Heer des Gegenkaisers Valerian jedoch n\u00e4her r\u00fcckt, wird Aemilianus wie seine Vorg\u00e4nger von seinen eigenen Truppen bei Spoletium umgebracht. In Rom wird der ehemalige Senator Valerian schnell an Stelle des kurzfristig in Rom herrschenden Silbannacus als rechtm\u00e4\u00dfiger Herrscher anerkannt. Er ernennt seinen Sohn Gallienus zum Mitherrscher und begibt sich in den Osten des Reichs, um dort die Perser zu stellen.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Thracia_SPQR.png/150px-Thracia_SPQR.png",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "253",
      "description": "Uranius Antoninus wird f\u00fcr kurze Zeit Gegenkaiser zu Aurelian in Syrien.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Bronze-Uranius_Antoninus-Elagabal_stone-SGI_4414.jpg/150px-Bronze-Uranius_Antoninus-Elagabal_stone-SGI_4414.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Römisches Reich",
      "granularity": "year"
    },
    {
      "date": "253",
      "description": "Zeit der Drei Reiche: Shu-Regent Fei Yi wird von dem Kriegsherrn Guo Xun in Chengdu ermordet. Jiang Wei wird f\u00fchrender Beamter in dem Staat. Auch Huang Hao gewinnt am Hof immer mehr Einfluss.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/41/China_5.jpg/150px-China_5.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Kaiserreich China",
      "granularity": "year"
    },
    {
      "date": "253",
      "description": "Wu-Regent Zhuge Ke plant einen gro\u00dfen Feldzug gegen die Wei-Dynastie, als Antwort auf die versuchte Invasion im Vorjahr. Auch Shu-Truppen sollen Wei angreifen, m\u00fcssen sich aufgrund schlechter Versorgung jedoch zur\u00fcckziehen. Wei-Regent Sima Shi gelingt es, die Wu-Armee zur\u00fcckzuschlagen und ihr bei Hefei eine bedeutende Niederlage zuzuf\u00fcgen. Regent Zhuge Ke wird sp\u00e4ter aufgrund seiner desastr\u00f6sen milit\u00e4rischen F\u00fchrung zusammen mit seiner ganzen Familie ermordet. Sun Jun wird neuer Regent.",
      "lang": "de",
      "image_url": "http://upload.wikimedia.org/wikipedia/commons/thumb/4/41/China_5.jpg/150px-China_5.jpg",
      "category1": "Politik und Weltgeschehen",
      "category2": "Kaiserreich China",
      "granularity": "year"
    }
  ]